<template>
    <v-dialog
        max-width="800"
        v-model="newdialog"
      >
          <v-card>
            <v-toolbar
              color="secondary"
                            class="white--text"
            ><v-toolbar-title class="font-weight-bold">Activity Log Details</v-toolbar-title>
            <v-spacer></v-spacer>
                            <v-btn icon class="white--text" @click="unset(false)">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
            </v-toolbar>

            <v-card-text class="mt-5">
               <v-list-item three-line class="mt-5 ml-2">
              <v-list-item-avatar
                size="80"
              >
              <img
										alt="user"
										src="/img/profile-11.png"
									>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ item.userName?item.userName:'Not Specified' }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{ item.meta.user.email?item.meta.user.email:'Not Specified' }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
       <v-row class="ml-2 mt-3">
            <v-col cols="4" class="" >
                       <label class="font-weight-bold">Time</label>
                           <v-text-field
                           :value="item.createdAt?item.createdAt:'Not Specified'"
                              readonly
                              outlined
                              
                           ></v-text-field>
            </v-col>
            <v-col cols="4" class="" >
                       <label class="font-weight-bold">UserId</label>
                           <v-text-field
                           :value="item.meta.user.userNumber?item.meta.user.userNumber:'Not Specified'"
                              readonly
                              outlined
                              
                           ></v-text-field>
            </v-col>
            <v-col cols="4" class="" >
                       <label class="font-weight-bold">Last Login</label>
                           <v-text-field
                           :value="item.lastLogin?item.lastLogin:'Not Specified'"
                              readonly
                              outlined
                              
                           ></v-text-field>
            </v-col>
              <v-col cols="4" class="" >
                       <label class="font-weight-bold">Terminal ID</label>
                           <v-text-field
                           :value="item.terminalID?item.terminalID:'Not Specified'"
                              readonly
                              outlined
                              
                           ></v-text-field>
            </v-col>
            <v-col cols="4" class="" >
                       <label class="font-weight-bold">Geographical Access Point</label>
                           <v-text-field
                           :value="item.accessPoint?item.accessPoint:'Not Specified'"
                              readonly
                              outlined
                              
                           ></v-text-field>
            </v-col>
            <v-col cols="4" class="" >
                       <label class="font-weight-bold">IP Address</label>
                           <v-text-field
                           :value="item.meta.location.clientIP?item.meta.location.clientIP:'Not Specified'"
                              readonly
                              outlined
                              
                           ></v-text-field>
            </v-col>
            <v-col cols="4" class="" >
                       <label class="font-weight-bold">File Accessed</label>
                           <v-text-field
                           :value="item.fileAccessed?item.fileAccessed:'Not Specified'"
                              readonly
                                outlined
                           ></v-text-field>
            </v-col>
             <v-col cols="4" class="" >

                     <label class="font-weight-bold">Module Accessed</label>
                           <v-text-field
                           :value=" item.module ? item.module:'Not Specified'"
                              readonly
                            outlined
                           ></v-text-field>
            </v-col>
            <v-col cols="4" class="" >
                        <label class="font-weight-bold">Function Accessed</label>
                           <v-text-field
                           :value="item.title ? item.title:'Not Specified'"
                              readonly
                             outlined
                           ></v-text-field>
            </v-col>
            <v-col cols="4" class="" >
                      <label class="font-weight-bold">Web Page URL</label>
                           <v-text-field
                           :value="item.webPage?item.webPage:'Not Specified'"
                              readonly
                              outlined
                           ></v-text-field>
            </v-col>
           
           
            <v-col cols="4" class="" >
                       <label class="font-weight-bold">Access Type</label>
                           <v-text-field
                           :value="item.accessType?item.accessType:'Not Specified'"
                              readonly
                            outlined
                           ></v-text-field>
            </v-col>
             <v-col cols="4" class="" >
                       <label class="font-weight-bold">Unsuccessful Login Attempts</label>
                           <v-text-field
                           :value="item.loginAttempts ? item.loginAttempts:'Not Specified'"
                              readonly
                              outlined
                           ></v-text-field>
            </v-col>
       </v-row>
            </v-card-text>
            <!-- <v-card-actions class="justify-end">
              <v-btn
                text
                @click="unset(false)"
              >Close</v-btn>
            </v-card-actions> -->
          </v-card>
      </v-dialog>
</template>
<script>
export default {
    name:"SinglePage",
    data(){
        return{
            dialog:true
        }
    },
    props:["newdialog", "unset", "item"]
}
</script>
<style scoped>
label {
  display: inline-block;
  margin-bottom: 0.2rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
  color: black;
}
</style>

